import { SITE } from './config';
import type { PageDef } from './config';

export function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.name,
    url: SITE.domain,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE.domain}/free-image-upscaler`,
      'query-input': 'required name=query',
    },
  };
}

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE.domain,
    logo: `${SITE.domain}/og-image.jpg`,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'support',
      email: SITE.supportEmail,
    },
  };
}

export function softwareApplicationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: SITE.name,
    applicationCategory: 'PhotographyApplication',
    operatingSystem: 'Any',
    url: SITE.domain,
    offers: [
      {
        '@type': 'Offer',
        name: 'Free',
        price: '0',
        priceCurrency: 'USD',
        description: '2 images per day, 2x upscale, Pro is watermark-free; free outputs include a watermark',
      },
      {
        '@type': 'Offer',
        name: 'Pro Monthly',
        price: '9.90',
        priceCurrency: 'USD',
        priceValidUntil: '2027-07-24',
        description: '100 images per month, 2x and 4x upscales, high-resolution output',
      },
      {
        '@type': 'Offer',
        name: 'Pro Yearly',
        price: '94.80',
        priceCurrency: 'USD',
        priceValidUntil: '2027-07-24',
        description: '100 images per month, 2x and 4x upscales, high-resolution output, billed annually',
      },
    ],
  };
}

export function faqSchema(items: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function howToSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'How to Enlarge an Image Without Losing Quality',
    step: [
      {
        '@type': 'HowToStep',
        name: 'Start with the best original',
        text: 'Use the highest-quality source image available.',
      },
      {
        '@type': 'HowToStep',
        name: 'Avoid heavy compression',
        text: 'Minimize compression artifacts before upscaling.',
      },
      {
        '@type': 'HowToStep',
        name: 'Use AI upscaling',
        text: 'Use an AI image upscaler instead of simple stretch resizing.',
      },
      {
        '@type': 'HowToStep',
        name: 'Pick the right scale',
        text: 'For large prints, use a 4x upscale with a Pro plan.',
      },
    ],
  };
}

export function breadcrumbsSchema(page: PageDef) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE.domain,
      },
      ...(page.path !== '/'
        ? [
            {
              '@type': 'ListItem',
              position: 2,
              name: page.label,
              item: `${SITE.domain}${page.path}`,
            },
          ]
        : []),
    ],
  };
}
